import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3dacd9de"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "auth-modal"
};
var _hoisted_2 = {
  "class": "auth-modal-box"
};
var _hoisted_3 = {
  "class": "content"
};
var _hoisted_4 = {
  "class": "auth-modal-button"
};
var _hoisted_5 = {
  "class": "button"
};
import { t } from '@/i18n';
import { computed, ref, unref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    value: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    maxCount: Number
  },
  emits: ['update:value'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var visible = ref(false);
    var curFiles = computed({
      get: function get() {
        return unref(props.value);
      },
      set: function set(value) {
        emit('update:value', value);
      }
    });
    var ua = navigator.userAgent.toLowerCase();
    var handleAuthClick = function handleAuthClick(event) {
      var node = event.target;
      if (window.isNotAuthModal && node.className === 'van-uploader__input') {
        if (window.sessionStorage.getItem('auth-uploader') === '1') return;
        event.preventDefault();
        visible.value = true;
        return;
      }
    };
    var handleVisible = function handleVisible() {
      visible.value = false;
      window.sessionStorage.setItem('auth-uploader', '1');
    };
    return function (_ctx, _cache) {
      var _component_van_uploader = _resolveComponent("van-uploader");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_uploader, {
        modelValue: _unref(curFiles),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(curFiles) ? curFiles.value = $event : null;
        }),
        "max-count": __props.maxCount,
        onClick: handleAuthClick
      }, null, 8, ["modelValue", "max-count"]), _createVNode(_Transition, {
        name: "fade"
      }, {
        "default": _withCtx(function () {
          return [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('allowEnter')), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
            "class": "button",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return visible.value = false;
            })
          }, _toDisplayString(_unref(t)('deny')), 1), _createElementVNode("div", _hoisted_5, [_createTextVNode(_toDisplayString(_unref(t)('allow')) + " ", 1), _createVNode(_component_van_uploader, {
            "class": "uploader",
            modelValue: _unref(curFiles),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return _isRef(curFiles) ? curFiles.value = $event : null;
            }),
            "max-count": __props.maxCount,
            onClick: handleVisible
          }, null, 8, ["modelValue", "max-count"])])])])], 512), [[_vShow, visible.value]])];
        }),
        _: 1
      })], 64);
    };
  }
});